import { render } from "./ColorDropdownItem.vue?vue&type=template&id=0fa408e0&scoped=true"
import script from "./ColorDropdownItem.vue?vue&type=script&lang=js"
export * from "./ColorDropdownItem.vue?vue&type=script&lang=js"

import "./ColorDropdownItem.vue?vue&type=style&index=0&id=0fa408e0&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa408e0"]])

export default __exports__